<div class="d-flex align-items-end mb-3">
    <h1 class="fs-3 fw-light mb-0">Locais de Apresentação</h1>
    <button mat-flat-button color="primary" class="ms-auto" [routerLink]="['/localidade/orgao', orgaoId, 'locais-apresentacao', 'novo']">NOVO LOCAL</button>
</div>
<generate-table 
    [dataSource]="dataSource" [columns]="columns" [loading]="loading" 
    [total]="pagination.total" [pageSize]="pagination.pageSize" 
    (pageEvent)="search($event)"
></generate-table>